<div *ngIf="!isReadonly || nestedFileForm?.controls['fileForm']?.controls?.length > 0" class="main-content">
  <app-review-section
    [title]="'basic-profile.fields.other_documents' | translate"
    [showAcceptRejectButtons]="false"
    [showMessages]="false"></app-review-section>

  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column" [formGroup]="nestedFileForm">
    <div formArrayName="fileForm">
      <div
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column"
        [formGroupName]="i"
        *ngFor="let fileData of nestedFileForm.controls['fileForm'].controls; let i = index">
        <div class="ui-g-6 margin-align">
          <input
            [id]="'float-input-bezeichnungeingn' + i"
            type="text"
            size="30"
            pInputText
            class="h4-button-and-field ui-input pInputText margin-text text-button-margin"
            formControlName="name"
            [placeholder]="'basic-profile.fields.enter_the_name' | translate"
            [readOnly]="checkInputForAvailableDocuments(i)" />
          <span>
            <p-fileUpload
              mode="basic"
              chooseIcon="pi pi-upload"
              styleClass="ui-fileupload-button"
              name="demo"
              uploadIcon="pi pi-upload"
              #form
              [chooseLabel]="'basic-profile.fields.date_upload' | translate"
              [id]="'float-input-upload' + i"
              (onSelect)="uploadHandler($event, i, form)"
              [disabled]="checkForAvailableDocuments(i)"></p-fileUpload>
          </span>
          <a
            *ngIf="environmentService.technicianRegistration.infoBubbles.showOtherDocumentsInfo"
            href="javascript:void(0)"
            [pTooltip]="'technician.tooltip.proof-of-designation' | translate"
            tooltipStyleClass="basic-tooltip">
            <i class="pi pi-info-circle hint-icon"></i>
          </a>
        </div>
        <div class="ui-g-4 ui-sm-12 ui-xs-12 margin-align margin-top-ten">
          <span *ngFor="let document of documents">
            <span *ngIf="document.name === nestedFileForm.controls['fileForm'].controls[i].controls.name.value">
              <a href="javascript:void(0)" (click)="downloadFile(document['document_id'], document.filename)">
                {{ document.filename }} ({{ document['filesize'] }})
              </a>
              <a *ngIf="!isReadonly" href="javascript:void(0)" class="margin-vertical-align" (click)="removeFile(document['document_id'])">
                <i class="pi pi-trash"></i>
              </a>
            </span>
          </span>
        </div>

        <div class="ui-g-1 ui-sm-12 ui-xs-12 margin-align margin-top-ten" style="float: right">
          <a
            href="javascript:void(0)"
            class="margin-vertical-align"
            (click)="removeRow(i)"
            *ngIf="nestedFileForm.controls['fileForm'].length > 1">
            <i class="pi pi-trash"></i>
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column" *ngIf="!isReadonly">
    <div class="ui-g-12 margin-align" style="cursor: pointer">
      <i class="pi pi-plus plus-icon" (click)="addForm()" tabindex="0" appEnterClick></i>
    </div>
  </div>
</div>
